module.exports = __webpack_public_path__ + "img/one-finger-swipe-left.c3766de9.svg";